import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheLoneExplorersView from "./sections/TheLoneExplorersView";
import HerenciaDeMendoza from "./sections/HerenciaDeMendoza";
import DistinguishedEstates from "./sections/DistinguishedEstates";
import NewArrivalsInTheVault from "./sections/NewArrivalsInTheVault";
import JoinTheCellarClub from "./sections/JoinTheCellarClub";
import VoicesOfOurGuests from "./sections/VoicesOfOurGuests";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheLoneExplorersView />
      <HerenciaDeMendoza />
      <DistinguishedEstates />
      <NewArrivalsInTheVault />
      <JoinTheCellarClub />
      <VoicesOfOurGuests />
      <Footer />
    </div>;
}